// src/components/Loader.tsx
import React from 'react';

const Loader: React.FC = () => {
  return (
    <div style={styles.container}>
      <div style={styles.spinnerWrapper}>
        <div style={styles.spinner} />
        <img src="/images/load.png" alt="Загрузка" style={styles.image} />
      </div>
      <style>{`
        @keyframes spin {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
};

const styles: Record<string, React.CSSProperties> = {
  container: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'rgba(255, 255, 255, 0.3)',
    backdropFilter: 'blur(8px)',
    zIndex: 9999,
  },
  spinnerWrapper: {
    position: 'relative',
    width: 120,
    height: 120,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  spinner: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    borderRadius: '50%',
    border: '4px solid transparent',
    borderTopColor: '#6a11cb',
    borderRightColor: '#2575fc',
    borderBottomColor: '#6a11cb',
    borderLeftColor: '#2575fc',
    animation: 'spin 1.2s linear infinite',
    boxShadow: '0 0 15px rgba(37, 117, 252, 0.3)',
  },
  image: {
    width: 90,
    height: 90,
    objectFit: 'contain',
    zIndex: 1,
  },
};

export default Loader;